import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { Lock, Security, Shield } from '@mui/icons-material';

const features = [
  {
    icon: <Lock sx={{ fontSize: 50, color: '#64ffda' }} />,
    title: 'Data Protection',
    description: 'We protect your personal data with the highest level of security.',
  },
  {
    icon: <Security sx={{ fontSize: 50, color: '#ffca28' }} />,
    title: 'Your Privacy Matters',
    description: 'Your personal information is never shared without your consent.',
  },
  {
    icon: <Shield sx={{ fontSize: 50, color: '#7c4dff' }} />,
    title: 'Top-Notch Security',
    description: 'We implement cutting-edge security measures to safeguard your data.',
  },
];

const GDPRCompliance = () => {
  return (
    <Box
      sx={{
        background: '#000000',
        py: 8,
        px: 3,
        textAlign: 'center',
        borderRadius: '20px',
        boxShadow: '0px 10px 30px rgba(0,0,0,0.6)',
        mt: 10,
        color: '#ffffff',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          letterSpacing: 2,
          textTransform: 'uppercase',
          fontSize: { xs: '1.6rem', md: '2.2rem' },
          mb: 2,
        }}
      >
        Data Privacy Matters
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          color: '#bbbbbb',
          fontSize: '1rem',
          mb: 6,
          maxWidth: 600,
          mx: 'auto',
        }}
      >
        Your privacy, data security, and trust are our top priority.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '16px',
                padding: '30px 20px',
                textAlign: 'center',
                transition: '0.3s ease all',
                boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.3)',
                '&:hover': {
                  transform: 'scale(1.03)',
                  borderColor: '#1E90FF',
                  boxShadow: '0px 12px 40px rgba(0,0,0,0.5)',
                },
              }}
            >
              <Box
                sx={{
                  width: 70,
                  height: 70,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                }}
              >
                {feature.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  color: '#ffffff',
                  textTransform: 'uppercase',
                  mb: 1,
                }}
              >
                {feature.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.9rem',
                  color: '#cccccc',
                  maxWidth: 280,
                  mx: 'auto',
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        sx={{
          mt: 5,
          background: 'linear-gradient(135deg, #1E90FF, #00C9FF)',
          color: '#fff',
          padding: '12px 24px',
          borderRadius: '30px',
          fontWeight: 'bold',
          fontSize: '0.9rem',
          letterSpacing: 1,
          textTransform: 'uppercase',
          boxShadow: '0px 4px 20px rgba(0,0,0,0.4)',
          transition: 'all 0.3s ease',
          '&:hover': {
            background: 'linear-gradient(135deg, #00BFFF, #00E5FF)',
            boxShadow: '0px 6px 30px rgba(0,0,0,0.5)',
          },
        }}
        onClick={() => window.open('/privacy-policy', '_blank')}
      >
        Learn More About Our Privacy Practices
      </Button>
    </Box>
  );
};

export default GDPRCompliance;
